// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1344":"css/app.6878","6097":"css/admin-app.6878"}[chunkId] + ".css";
};